import { DataManager } from '@syncfusion/ej2-data';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RecordDoubleClickEventArgs, RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { ExportInterfaceEmailTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { EmailTemplatesOverviewService } from './email-templates-overview.service';
import { UntypedFormGroup } from '@angular/forms';
import { ModalService } from '../../../../base/shared/modal/modal.service';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-email-templates-overview',
    templateUrl: './email-templates-overview.component.html',
    styleUrls: ['./email-templates-overview.component.scss'],
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
    ]
})
export class EmailTemplatesOverviewComponent extends GridBaseComponent<any> implements OnInit {
  @Output() rowSelected = new EventEmitter<ExportInterfaceEmailTemplateDTO>();
  @Output() recordDoubleClick = new EventEmitter<ExportInterfaceEmailTemplateDTO>();

  @Input() public emailTemplateForm: UntypedFormGroup;
  @Input() public set selectedTemplateId(value: number) {
    if (value !== this._selectedTemplateId) {
      this._selectedTemplateId = value;
      if (value !== null && value !== undefined) {
        this.grid?.selectRows([this.grid.getRowIndexByPrimaryKey(value)]);
      } else {
        this.grid?.selectRows([]);
      }
    }
  }

  private addedRecordId: number = null;
  private previousRowIndex: number;
  private _selectedTemplateId: number;

  constructor(
    translateService: TranslateService,
    protected templatesService: EmailTemplatesOverviewService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
  ) {
    super(translateService, templatesService);
  }

  ngOnInit() {
    this.isActiveColumnName = 'Active';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.templatesService, this.spinnerService),
    });
    this.templatesService.oneTimeFilterTemplateId = this._selectedTemplateId;
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    if (this.emailTemplateForm?.dirty) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.email-templates.discard-dialog.title', 'i18n.domain.export-configuration.email-templates.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.data as ExportInterfaceEmailTemplateDTO;
        if (data) {
          this._selectedTemplateId = data.id;
          this.rowSelected.emit(data);
          this.previousRowIndex = this.grid?.selectedRowIndex;
        }
      });
      dialog.onCancelSubject.subscribe(() => {
        this.grid.selectRows([this.previousRowIndex]);
      });
    } else {
      const data = args.data as ExportInterfaceEmailTemplateDTO;
      if (data) {
        this._selectedTemplateId = data.id;
        this.rowSelected.emit(data);
        this.previousRowIndex = this.grid?.selectedRowIndex;
      }
    }
  }

  public onRecordDoubleClick(args: RecordDoubleClickEventArgs): void {
    const data = args.rowData as ExportInterfaceEmailTemplateDTO;
    if (data) {
      this.recordDoubleClick.emit(data);
    }
  }

  public recordAdded(id: number) {
    this.addedRecordId = id;
    this.grid.refresh();
  }

  public onDataBound() {
    if (this.addedRecordId) {
      const index = this.grid?.getRowIndexByPrimaryKey(this.addedRecordId);
      this.grid?.selectRow(index);
      this.addedRecordId = null;
      if (this.previousRowIndex >= index) {
        this.previousRowIndex += 1;
      }
    }
    if (this._selectedTemplateId && this.grid?.selectedRowIndex < 0) {
      const index = this.grid?.getRowIndexByPrimaryKey(this._selectedTemplateId);
      this.grid?.selectRow(index);
    }
  }

  public refresh(): void {
    this.grid.refresh();
  }

  public resetRowSelected(): void {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid.selectRows([]);
    }
  }

  protected initializeEditForm(data: ExportInterfaceEmailTemplateDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

}
